module.exports = __webpack_public_path__ + "media/images/hp@2x-21217a963c2299b636f25c6c258e3dc2.webp";